import { Injectable } from '@angular/core';
import { HttpClient } from './http-client';
import { BehaviorSubject } from 'rxjs';
import { BaseEntityService } from './baseentity-service';

export const DOLAR_PESOS_ID = -1;
export const DOLAR_ID = 2;
export const MONEDA_PESIFICACION = {ID: -1, Moneda: 'Dólares a Pesificar', Simbolo: 'u$p' };

@Injectable()
export class MonedaService extends BaseEntityService {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    responseItemToEntity(responseItem: any): Moneda {
        return {
            ID: responseItem.Id,
            Moneda: responseItem.Moneda,
            Simbolo: responseItem.Simbolo
        };
    }

    apiRoute: string = '/api/moneda';
}

export interface Moneda {
  ID: number;
  Moneda: string;
  Simbolo: string;
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/moneda-service.ts